module.exports = __webpack_public_path__ + "img/case-211-main-clean.dc545579.png";